import { AgChartOptions } from "ag-charts-community";
import { AgCharts } from "ag-charts-react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional Theme applied to the grid
import "ag-grid-enterprise";
import { useMemo } from "react";

import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { useTheme } from "next-themes";

const BarComboTransactionCost = ({
  filteredData,
}: {
  filteredData: IBaseAnalyticsCombined[];
}) => {
  const { theme } = useTheme();

  const options = useMemo<AgChartOptions | any>(() => {
    return {
      background: {
        visible: false,
      },
      theme: theme == "dark" ? "ag-default-dark" : "ag-default",
      data: filteredData,
      //         [
      //     { date: "2024-06-25", barValue: 5, lineValue: 6 },
      //     { date: "2024-06-27", barValue: 8, lineValue: 7 },
      //     { date: "2024-06-30", barValue: 6, lineValue: 5 },
      //     { date: "2024-07-03", barValue: 9, lineValue: 12 },
      //     // ... keep filling with your real data
      //   ],
      series: [
        {
          type: "bar",
          xKey: "dateTimeSent",
          yKey: "tradeCostVsMid",
          fill: theme == "dark" ? "#5F3113" : "#A97456",
          stacked: false,
          legendItemName: "Trade Cost Vs Mid",
          highlightStyle: {
            item: {
              fill: "#FC6A08", // Change fill color on hover - Cube Orange
            },
          },
        },
        {
          type: "line",
          xKey: "dateTimeSent",
          yKey: "spreadToMid",
          stroke: "lightgreen", // lime-green line
          strokeWidth: 2,
          marker: { enabled: false }, // disable markers
          legendItemName: "Spread To Mid",
        },
      ],
      axes: [
        {
          type: "category",
          position: "bottom",
          // format as months + quarters
          label: {
            formatter: (params: any) => {
              const date = new Date(params.value);
              const day = date.getDate();
              const month = date.toLocaleString("default", {
                month: "short",
              });
              const year = date.toLocaleString("default", {
                year: "2-digit",
              });
              return `${day}\n${month}\n${year}`; // stacked day + month
            },
          },
          tick: { size: 1 },
        },
        {
          type: "number",
          position: "left",
          keys: ["tradeCostVsMid"],
          title: { text: "Trade Cost Vs Mid" },
          label: {
            formatter: (params: any) => {
              return "$" + params.value.toLocaleString();
            },
          },
        },
        {
          type: "number",
          position: "right",
          keys: ["spreadToMid"],
          title: { text: "Spread To Mid" },
          // id: "lineAxis",
        },
      ],
      legend: { enabled: true, position: "top" },
      padding: { left: 40, right: 30, top: 20, bottom: 40 },
    };
  }, [theme, filteredData]);
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex h-fit w-full">Transaction Costs</div>
      <div className="flex h-full">
        <AgCharts
          className="flex h-full w-full"
          // ref={chartRef}
          options={options}
        />
      </div>
    </div>
  );
};

export default BarComboTransactionCost;
